import React, {useEffect, useState} from "react";
import FormHandler from "../utils/FormHandler";
import axios from "axios";
import {toast} from "react-toastify";
import {toggleLoader} from "../actions/setting";
import {useDispatch} from "react-redux";
import {validateResetPassword} from "../utils/SharedFormValidationRules";
import { useLocation, useNavigate } from "react-router-dom";


const Reset = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showText, setShowText] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    handleOnBlur,
    setError,
  } = FormHandler(reset, validateResetPassword);

  function reset() {
    setIsLoading(true);
    setError("api", null);
  }

  useEffect(() => {
    if (!isLoading) {
      return;
    }
    dispatch(toggleLoader(true));

    const queryParams = new URLSearchParams(location.search);
    const key = queryParams.get("hash");
    const username = queryParams.get("uname");

    const payload = {
      ...values,
      key,
      username
    };

    axios.post(process.env.REACT_APP_HOST + '/reset-password', payload)
      .then(function (response) {
        setIsLoading(false);
        toast.success("Password reset successful, please login to continue...");
        dispatch(toggleLoader(false));
        navigate("/login");
      })
      .catch(function (error) {
        if (error.response && error.response.status === 422) {
          setError("api", error.response.data.message);
        } else {
          setError("api", "An error occurred while resetting password");
        }
        setIsLoading(false);
        dispatch(toggleLoader(false));
      });
  }, [isLoading, location.search]);

  return (
    <div className="login-background" id="login">
      <div className="login-inner">
        <div className="login-box">
          <div className="sa-modal-header">
            Reset password
          </div>

          <form onSubmit={handleSubmit} noValidate>
            <div className="form-group m-b-6">
              <label htmlFor="pwd">Password</label>
              <input type={!showText ? "password" : "text"} value={values.password || ''} onChange={handleChange}
                     onBlur={handleOnBlur}
                     className={`black-text-textarea ${errors.password ? "form-control warning-input" : "form-control"}`}
                     name="password"
                     placeholder="Enter your password"/>
              <span className="fa fa-fw fa-eye field-icon toggle-password" onClick={() => setShowText(!showText)}/>
              {errors.password && (<p className="warning-input-msg">{errors.password}</p>)}
            </div>
            <div className="form-group m-b-6">
              <label htmlFor="pwd">Confirm Password</label>
              <input type={!showText ? "password" : "text"} value={values.confirmPassword || ''} onChange={handleChange}
                     onBlur={handleOnBlur}
                     className={`black-text-textarea ${errors.confirmPassword ? "form-control warning-input" : "form-control"}`}
                     name="confirmPassword" placeholder="Enter your password"/>
              <span className="fa fa-fw fa-eye field-icon toggle-password" onClick={() => setShowText(!showText)}/>
              {errors.confirmPassword && (<p className="warning-input-msg">{errors.confirmPassword}</p>)}
              {!errors.confirmPassword && !errors.password && errors.match && (
                <p className="warning-input-msg">{errors.match}</p>)}
            </div>
            {errors.api && (<div className={"login-warning-msg"}>{errors.api}</div>)}
            <button className="btn btn-sa-primary w-100 m-b-14">SUBMIT</button>
          </form>
        </div>
      </div>
    </div>);
};


export default Reset;
